import React, { Component } from 'react';
import { sortBy, sum } from 'lodash';

import LoadingIndication from '../../common/loading-indicator';
import { Chart } from './multi-stacked-bar-chart';

class MultiStackedBarChartTagsAvailableArticlesStats extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isError: false,      
      stats: [],
    };
  }

  componentDidMount() {
    this.props.getArticles()
      .then((stats) => {
        this.setState(() => {
          return {
            isLoading: false,
            isError: false,
            stats: sortBy(stats, (tagStats) => sum(Object.values(tagStats.counts))).reverse(),
            xFamilyKeys: ['counts', 'uniqueTagCounts'],
            xKeys: ['medium', 'devTo']//, 'others'],
          };
        }); 
      })
      .catch(error => {
        console.error('MultiStackedBarChartTagsAvailableArticlesStats::componentDidMount', error);
        this.setState({
          isLoading: false,
          isError: true
        });
      });
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingIndication />;
    }

    if (this.state.isError) return <div>Error</div>;

    const { stats, xKeys, xFamilyKeys } = this.state;

    const statsSeparation = [];
    const tagsPerChart = 5;
    for (let i = 0; i < stats.length; i += tagsPerChart) {
      statsSeparation.push(stats.slice(i, i + tagsPerChart));
    }     

    return (
      <div style={{ margin: '30px 0' }}>
        {
          statsSeparation.map(chartStats => (
            <Chart stats={chartStats} xKeys={xKeys} xFamilyKeys={xFamilyKeys} />
          ))
        }
      </div>
    );
  }
}

export default MultiStackedBarChartTagsAvailableArticlesStats;
